export default __webpack_public_path__ + "837746af3f6dbcdb2d61605b3a787fc9.gif";